import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Globe, Code, Search, Shield, Zap, CheckCircle2 } from "lucide-react";

const DOMAIN = "sorgupanel.org";

export default function SeoTools() {
  const seoUrl = (p) => p;

  const features = [
    { icon: Zap, title: "Çok Hızlı Yükleme", desc: "Optimize edilmiş, hafif ve anında açılan sayfalar." },
    { icon: Globe, title: "Anlık Sitemap", desc: "Yeni eklenen her sayfa otomatik sitemap.xml'e girer." },
    { icon: Shield, title: "Anlık İndeksleme", desc: "Yönetici tek tıkla Google'a bildirir, sayfalar hızla dizine girer." },
    { icon: Code, title: "Tam SEO Kontrolü", desc: "Her sayfa için meta, canonical, noindex ayarları." },
  ];

  return (
    <div>
      <section className="bg-gradient-to-br from-blue-700 to-indigo-700 text-white relative overflow-hidden">
        <div className="absolute inset-0 hero-grid opacity-40" />
        <div className="relative max-w-5xl mx-auto px-4 sm:px-6 py-16 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/15 text-sm mb-5 backdrop-blur"><Search className="h-4 w-4" /> SEO & Google İndeksleme</div>
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight">Tüm site tamamen<br />SEO uyumlu.</h1>
          <p className="mt-4 text-blue-100 max-w-2xl mx-auto">Anlık güncellenen sitemap, robots.txt, Google Search Console entegrasyonu ve gerçek Google indeks bildirimi (yönetici panelinden).</p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <a href={seoUrl("/sitemap.xml")} target="_blank" rel="noreferrer" data-testid="hero-sitemap-link"><Button className="h-11 px-6 bg-white text-blue-700 hover:bg-blue-50"><Globe className="h-4 w-4 mr-2" /> sitemap.xml</Button></a>
            <a href={seoUrl("/robots.txt")} target="_blank" rel="noreferrer" data-testid="hero-robots-link"><Button variant="outline" className="h-11 px-6 border-white/40 text-white bg-white/10 hover:bg-white/20"><Code className="h-4 w-4 mr-2" /> robots.txt</Button></a>
          </div>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-4 sm:px-6 py-16">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((f, i) => (
            <div key={i} className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-6">
              <f.icon className="h-6 w-6 text-blue-600 mb-3" />
              <h3 className="font-semibold text-slate-900 dark:text-white">{f.title}</h3>
              <p className="text-sm text-slate-500 mt-1.5">{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="grid sm:grid-cols-2 gap-4 mt-8">
          <a href={seoUrl("/sitemap.xml")} target="_blank" rel="noreferrer" data-testid="seo-sitemap-link" className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-6 hover:shadow-md hover:border-blue-300 transition-all group flex items-center gap-4">
            <div className="h-12 w-12 rounded-xl bg-blue-50 dark:bg-blue-950/40 grid place-items-center"><Globe className="h-6 w-6 text-blue-600" /></div>
            <div>
              <h4 className="font-semibold group-hover:text-blue-600">Sitemap.xml</h4>
              <p className="text-sm text-slate-500 font-mono">{DOMAIN}/sitemap.xml</p>
            </div>
          </a>
          <a href={seoUrl("/robots.txt")} target="_blank" rel="noreferrer" data-testid="seo-robots-link" className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-6 hover:shadow-md hover:border-blue-300 transition-all group flex items-center gap-4">
            <div className="h-12 w-12 rounded-xl bg-blue-50 dark:bg-blue-950/40 grid place-items-center"><Code className="h-6 w-6 text-blue-600" /></div>
            <div>
              <h4 className="font-semibold group-hover:text-blue-600">Robots.txt</h4>
              <p className="text-sm text-slate-500 font-mono">{DOMAIN}/robots.txt</p>
            </div>
          </a>
        </div>

        <div className="mt-8 bg-blue-50 dark:bg-blue-950/30 border border-blue-200 dark:border-blue-900/40 rounded-xl p-6 flex items-start gap-4">
          <CheckCircle2 className="h-6 w-6 text-blue-600 shrink-0 mt-0.5" />
          <div>
            <h4 className="font-semibold text-slate-900 dark:text-white">Tüm sayfalar hemen indekslenmeye hazır</h4>
            <p className="text-sm text-slate-500 mt-1">Oluşturduğunuz her HTML sayfa ve sorgulanan her numara otomatik olarak sitemap'e eklenir. Google'a gerçek indeks bildirimi ve Search Console doğrulaması yönetici panelinden yönetilir.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
